/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FAVORED_CONTACT_DELETE,
  FAVORED_CONTACT_FAVORITE,
  FAVORED_CONTACT_LIST,
  SET_NEW_CONTACT,
} from '~/actions/actionTypes';

const initialState: reducers.FavoredContactReducer = {
  list: [],
  count: 0,
  newContact: null,
};

const favoredContactReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FAVORED_CONTACT_LIST:
      state = {
        ...state,
        list: action.payload.rows,
        count: action.payload.count,
      };
      break;
    case FAVORED_CONTACT_FAVORITE: {
      const changedContact = state.list.find(
        (contact) => contact.id === action.payload.id
      );

      const newContacts = state.list.map((contact) => {
        if (contact.id !== changedContact?.id) {
          return contact;
        } else {
          return {
            ...contact,
            isFavorite: action.payload.isFavorite,
          };
        }
      });

      state = {
        ...state,
        list: newContacts,
      };
      break;
    }
    case FAVORED_CONTACT_DELETE:
      state = {
        ...state,
        list: state.list.filter((contact) => contact.id !== action.payload),
      };
      break;
    case SET_NEW_CONTACT:
      state = {
        ...state,
        list: action.payload ? state.list.concat(action.payload) : state.list,
        newContact: action.payload,
      };
      break;
    default:
      return state;
  }

  return state;
};

export default favoredContactReducer;
